if (!customElements.get("location-modal-opener")) {
  customElements.define(
    "location-modal-opener",
    class LocationModalOpener extends HTMLElement {
      constructor() {
        super()

        this.locationModal = document.getElementById("LocationModal")
        this.labels = this.querySelectorAll("label")
          ;[...this.labels].forEach((label) => {
            label.addEventListener("click", this.openModal.bind(this))
            label.addEventListener("keydown", (e) => {
              if (e.key !== " " && e.key !== "Enter") {
                return
              }

              this.openModal(e)
            })
          })

        this.updateLocationUI()
        subscribe(PUB_SUB_EVENTS.bevmoLocationUpdate, this.updateLocationUI.bind(this))
      }

      openModal(evt) {
        this.locationModal.setDeliveryTypeUi(evt.currentTarget.control.value)
        this.locationModal.showModal(evt.currentTarget)
      }

      updateLocationUI() {
        const currentlyChecked = this.querySelector("input:checked")
        const fulfillmentDisplayName = bevmoLocation.fulfillment_display_name || `Enter Address`
        
        // Update elements with data-header-address (usually nested inside data-show-location-modal)
        document.querySelectorAll(`[data-header-address]`).forEach((address) => {
          address.innerHTML = fulfillmentDisplayName
        })
        
        // Also update elements with data-show-location-modal that don't have data-header-address
        // Update their text content or title attribute
        this.querySelectorAll(`[data-show-location-modal]`).forEach((element) => {
          // Only update if it doesn't have a data-header-address child (already handled above)
          if (!element.querySelector(`[data-header-address]`)) {
            // Update title attribute for accessibility
            element.setAttribute('title', fulfillmentDisplayName)
            // Update text content if it's a text node
            if (element.textContent && element.textContent.trim() && !element.querySelector('span')) {
              element.textContent = fulfillmentDisplayName
            }
          }
        })
        
        const selectedFulfillmentType = document.querySelector(`[data-selected-fulfillment-type]`)
        if (selectedFulfillmentType) {
          selectedFulfillmentType.classList.remove(`selected-fulfillment-type--pickup`)
          selectedFulfillmentType.classList.remove(`selected-fulfillment-type--delivery`)
          selectedFulfillmentType.classList.remove(`selected-fulfillment-type--shipping`)
          selectedFulfillmentType.classList.add(`selected-fulfillment-type--${bevmoLocation.fulfillment_type}`)
        }

        if (currentlyChecked && currentlyChecked.value != bevmoLocation.fulfillment_type) {
          currentlyChecked.checked = false
          this.querySelector('input[value="' + bevmoLocation.fulfillment_type + '"]').checked = true
        }
      }
    }
  )
}

if (!customElements.get("location-modal")) {
  customElements.define(
    "location-modal",
    class LocationModal extends ModalDialog {
      constructor() {
        super()
        this.autocompleteInitialized = false
        this.autocompleteInputField = this.querySelector("#LocationModal-custom-autocomplete")
        this.autocompleteInput = this.querySelector("#LocationModal-custom-autocomplete-input")
        this.mapElement = this.querySelector(".location-modal__map")
        this.submitButton = this.querySelector(".location-modal__submit")
        this.pickupLocationsElement = this.querySelector(`.location-modal__pickup-locations`)
        this.place
        this.selectedPickupLocationId = null
        this.form = this.querySelector("form")
        this.availabilities = null

        // Initialize map manager
        this.mapManager = new MapManager(this.mapElement)

        this.querySelector(".location-modal__toggle").addEventListener("click", this.onCloseModal.bind(this))
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this))
        this.renderBevmoLocationState()
        this.setDeliveryTypeUi(bevmoLocation.fulfillment_type)
        this.form.querySelectorAll(`input[name="selected_delivery_type"]`).forEach((input) => {
          input.addEventListener("change", (event) => {
            this.setDeliveryTypeUi(event.target.value)
            this.focusInput()
          })

          const label = this.form.querySelector(`label[for="${input.id}"]`)
          label.addEventListener("keydown", (event) => {
            if (event.key !== " " && event.key !== "Enter") {
              return
            }

            this.setDeliveryTypeUi(input.value)
            this.focusInput()
          })
        })

        this.pickupLocationTemplate = document.getElementById(`LocationModalPickupLocationTemplate`)
        this.pickupLocationList = this.querySelector(".location-modal__pickup-locations")
        this.pickupLocationList.addEventListener("change", this.onPickupLocationChange.bind(this))

        window.openLocationModal = this.showModal.bind(this)
        subscribe(PUB_SUB_EVENTS.bevmoLocationUpdate, this.renderBevmoLocationState.bind(this))
      }

      getIsBevmoLocationDefaultStore() {
        return Boolean(bevmoLocation && bevmoLocation.address && bevmoLocation.address.is_store)
      }

      getIsPlaceDefaultStore() {
        if (!this.place) {
          return false
        }

        if (this.default_pickup_place) {
          return this.getIsPlaceMatch(this.place, this.default_pickup_place)
        }

        if (!this.getIsBevmoLocationDefaultStore()) {
          return false
        }

        return Boolean(
          this.place.place_id === bevmoLocation.address.place_id ||
          this.place.formatted_address === bevmoLocation.address.addressStr
        )
      }

      getIsPlaceMatch(place1, place2) {
        return LocationValidator.isPlaceMatch(place1, place2)
      }

      getIsPlaceSet(place) {
        return Boolean(this.place && this.getIsPlaceMatch(this.place, place))
      }

      getIsBevmoLocationValidForTab() {
        if (!bevmoLocation || !bevmoLocation.address) {
          return false
        }

        const isValid = this.validateUserAddress(bevmoLocation.address)

        return isValid
      }

      toggleSubmitButtonState(isDisabled, isLoading = false) {
        if (isLoading) {
          this.submitButton.classList.add("loading")
        } else {
          this.submitButton.classList.remove("loading")

          if (isDisabled === null) return

          this.submitButton.disabled = isDisabled
        }
      }

      renderBevmoLocationState() {
        if (this.getIsBevmoLocationValidForTab()) {
          for (const [key, value] of Object.entries(bevmoLocation.address)) {
            const form_field = this.form.querySelector(`[name="${key}"]`)

            if (form_field) {
              this.form.querySelector(`[name="${key}"]`).value = value
            }
          }
        }

        if (bevmoLocation.fulfillment_type == "pickup") {
          this.selectedPickupLocationId = bevmoLocation.location_id
        }
      }

      onCloseModal() {
        // if (window.localStorage.getItem('delivery_location') == null) {
        //   window.localStorage.setItem('delivery_location_dismissed', true);
        // }
      }

      getLoadingContent(placeholders_count = 5) {
        return ShippingManager.getLoadingContent(placeholders_count)
      }

      async setMapLocation(position) {
        await this.mapManager.setMapLocation(position)
      }

      clearPlace() {
        this.place = null
        this.address = null
        ShippingManager.clearPlaceData(this.form, this.autocompleteInput)
        this.clearMap()
        this.focusInput()
        this.resetFulfillmentTypeNotices()
        this.toggleSubmitButtonState(null, false)
        this.updateConfirmButton()
      }

      clearMap() {
        this.mapElement = this.mapManager.clearMap()
      }

      formatPlace(place, ignoreAddress1) {
        return LocationValidator.formatPlace(place, ignoreAddress1)
      }

      async placeChanged(providedPlace = null) {
        const locationPlaceId = bevmoLocation && bevmoLocation.address ? bevmoLocation.address.place_id : null

        const locationAddressAutocomplete =
          bevmoLocation && bevmoLocation.address ? bevmoLocation.address.autocomplete : null

        const locationAddressStr = bevmoLocation && bevmoLocation.address ? bevmoLocation.address.addressStr : null

        const addressQuery = locationAddressStr || locationAddressAutocomplete

        const fullPlace =
          providedPlace ||
          (await window.bevmoLocation.getPlaceForAddress(addressQuery, locationPlaceId)) ||
          (await window.bevmoLocation.getPlaceForAddress(this.autocompleteInput.value, null))
        const ignoreAddress1 = Boolean(
          !providedPlace && locationPlaceId && (!bevmoLocation.address.address1 || bevmoLocation.address.is_store)
        )
        this.place = this.formatPlace(fullPlace, ignoreAddress1)

        this.setDefaultPickupPlace()
        this.prepareModalForPlace()
      }

      validateUserAddress(address) {
        return LocationValidator.validateUserAddress(address, this.current_fulfillment_type)
      }

      validateParsedAddress(parsedAddress) {
        return LocationValidator.validateParsedAddress(parsedAddress, this.current_fulfillment_type)
      }

      populateForm(parsedAddress) {
        return ShippingManager.populateForm(this.form, parsedAddress)
      }

      getIsMapEnabledForTab() {
        const isMapEnabledForTab = Boolean(this.current_fulfillment_type !== `pickup`)

        return isMapEnabledForTab
      }

      async prepareModalForPlace() {
        const place = this.place
        const parsedAddress =
          place && place.address_components
            ? parseAddressComponents(place)
            : {
              lat: Number(this.form.querySelector("[name=latitude]").value),
              lng: Number(this.form.querySelector("[name=longitude]").value),
            }

        const { isValid, message } = this.validateParsedAddress(parsedAddress)

        if (isValid) {
          this.handleErrorMessage()
        } else {
          this.handleErrorMessage(message)

          return
        }

        if (document.activeElement === document.body) {
          // came from autocomplete
          this.form.querySelector("[name=unit]").focus()
        }

        if (this.getIsModalOpen() && this.getIsMapEnabledForTab()) {
          if (!this.getIsPlaceSet(place)) {
            return
          }

          const { lat, lng } = parsedAddress
          await this.setMapLocation({ lat, lng })

          if (!this.getIsPlaceSet(place)) {
            return
          }
        }

        this.toggleSubmitButtonState(true, true)
        this.toggleLoadingStateForPickupLocations(true)
        const formDataObject = this.populateForm(parsedAddress)
        const deliveryZone = await window.bevmoLocation.getDeliveryZone(formDataObject)

        if (!this.getIsPlaceSet(place)) {
          return
        }

        this.toggleSubmitButtonState(!deliveryZone, false)

        if (!deliveryZone) {
          this.handleErrorMessage(window.gopuffShopify.strings.delivery_zone_request_error)

          return
        }

        this.address = formDataObject
        this.delivery_zone_response = deliveryZone
        this.availabilities = bevmoLocation.getAvailabilitiesForDeliveryZone(deliveryZone)
        this.updatedDeliveryZones()
      }

      toggleLoadingStateForPickupLocations(state) {
        ShippingManager.toggleLoadingStateForPickupLocations(this.pickupLocationsElement, state)
      }

      getSelectedPickupLocationId() {
        return ShippingManager.getSelectedPickupLocationId(this.delivery_zone_response, this.selectedPickupLocationId)
      }

      renderPickupLocations() {
        this.pickupLocationsElement.innerHTML = ""
        const pickupLocationsExist = Boolean(
          this.delivery_zone_response &&
          this.delivery_zone_response.pickup_locations &&
          this.delivery_zone_response.pickup_locations.length > 0
        )

        if (!pickupLocationsExist) {
          return
        }

        this.delivery_zone_response.pickup_locations.forEach((store) => {
          this.pickupLocationsElement.appendChild(this.renderPickupLocation(store))
        })

        this.selectedPickupLocationId = this.getSelectedPickupLocationId()
        this.form.querySelector(
          `input[type="radio"][name="selected_nearest_store"][value="${this.selectedPickupLocationId}"]`
        ).checked = true
      }

      renderPickupLocation(location) {
        return ShippingManager.renderPickupLocation(location, this.pickupLocationTemplate)
      }

      resetFulfillmentTypeNotices() {
        const notices = this.querySelectorAll(`.location-modal__notice`)

        notices.forEach((notice) => {
          notice.classList.add("hidden")
        })
      }

      setFulfillmentTypeNotice(fulfillment_type, available) {
        const notice = this.querySelector(`.location-modal__notice[data-delivery-type="${fulfillment_type}"]`)
        if (!notice) {
          return
        }

        if (available) {
          notice.classList.add("hidden")
        } else {
          notice.classList.remove("hidden")
        }
      }

      updatedDeliveryZones() {
        this.toggleLoadingStateForPickupLocations(false)

        if (this.delivery_zone_response.error) {
          this.handleErrorMessage(this.delivery_zone_response.error_message)
          console.error(this.delivery_zone_response)
          return
        }

        this.handleErrorMessage(false)
        this.renderPickupLocations()

        for (const availability_key in this.availabilities) {
          this.setFulfillmentTypeNotice(availability_key, this.availabilities[availability_key])
        }

        this.updateConfirmButton()
        gopuffCustomAnalytics.publishEvent(`gopuff_fulfillment_type_options`, this.availabilities)
      }

      updateConfirmButton() {
        let confirmButtonDisabled = Boolean(!this.place || !this.address)

        if (!confirmButtonDisabled) {
          switch (this.current_fulfillment_type) {
            case "pickup":
              confirmButtonDisabled = !this.getSelectedPickupLocationId()
              break
            case "delivery":
              confirmButtonDisabled =
                !this.delivery_zone_response?.delivery_location ||
                this.delivery_zone_response?.delivery_location?.id === -1
              break
            default:
              confirmButtonDisabled =
                !this.delivery_zone_response?.shipping_location ||
                this.delivery_zone_response?.shipping_location?.id === -1
          }
        }

        this.toggleSubmitButtonState(confirmButtonDisabled)

        reTrapFocus()
        return confirmButtonDisabled
      }

      async initAutocomplete() {
        subscribe(PUB_SUB_EVENTS.customLocationComponentPlaceChanged, (event) => {
          if (event.source === `LocationModal-custom-autocomplete`) {
            this.placeChanged(event.place)
          }
        })

        this.autocompleteInputField.addEventListener(
          CUSTOM_LOCATION_AUTOCOMPLETE_COMPONENT_EVENTS.LOADING_STARTED,
          () => {
            this.toggleSubmitButtonState(true, true)
          }
        )
        this.autocompleteInputField.addEventListener(
          CUSTOM_LOCATION_AUTOCOMPLETE_COMPONENT_EVENTS.LOADING_FINISHED,
          () => {
            this.toggleSubmitButtonState(null, false)
          }
        )
        await this.autocompleteInputField.initGoogle()

        this.autocompleteInitialized = true
      }

      async showModal(opener = null) {
        this.show(opener)
        this.focus()

        if (this.autocompleteInput.value === "") {
          this.toggleSubmitButtonState(true)
        }

        if (!this.autocompleteInitialized) {
          await this.initAutocomplete()
        }

        this.checkLocation()
        this.focusInput()
      }

      focusInput() {
        if (this.getIsBevmoLocationValidForTab()) {
          return
        }

        const emptyInput = this.form.querySelector("[name=autocomplete]:placeholder-shown")

        if (!emptyInput) {
          return
        }

        emptyInput.focus()
      }

      hide() {
        document.body.classList.remove("overflow-hidden")
        document.body.dispatchEvent(new CustomEvent("modalClosed"))
        this.removeAttribute("open")
        removeTrapFocus(this.openedBy)
        window.pauseAllMedia()

        if (document.querySelector(`cart-drawer`).isOpen) {
          document.querySelector(`cart-drawer`).open()
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.form.querySelector(".location-modal__error")
        this.errorMessage = this.errorMessage || this.form.querySelector(".location-modal__error-message")

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage)

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage
        }
      }

      setModalStyles(delivery_type) {
        this.classList.remove(`location-modal--pickup`)
        this.classList.remove(`location-modal--delivery`)
        this.classList.remove(`location-modal--shipping`)
        this.classList.add(`location-modal--${delivery_type}`)
      }

      setDeliveryTypeUi(delivery_type) {
        this.current_fulfillment_type = delivery_type

        this.form.querySelectorAll("[data-delivery-type]").forEach((item) => {
          item.style.display = "none"
        })

        this.form.querySelectorAll(`[data-delivery-type="${delivery_type}"]`).forEach((item) => {
          item.style.display = ""
        })

        this.form.querySelector("[name=unit]").parentElement.style.display = delivery_type === "pickup" ? "none" : ""

        this.form.querySelector(`input[name="selected_delivery_type"][value="${delivery_type}"]`).checked = true

        this.setModalStyles(delivery_type)
        this.checkLocation()
        this.updateConfirmButton()
      }

      validatePlace() {
        if (!this.place) {
          return false
        }

        if (this.getIsPlaceDefaultStore() && this.current_fulfillment_type !== `pickup`) {
          return false
        }

        const { isValid: isAddressValid } = this.validateParsedAddress(parseAddressComponents(this.place))

        return isAddressValid
      }

      clearAutocompleteFromBevmoLocation() {
        if (!(window.bevmoLocation && window.bevmoLocation.address)) {
          return
        }

        if (window.bevmoLocation.address.autocomplete !== this.autocompleteInput.value) {
          return
        }

        this.autocompleteInput.value = ``
      }

      checkLocation() {
        if (this.place) {
          const isValid = this.validatePlace(this.place)

          if (isValid) {
            this.prepareModalForPlace()

            return
          }

          this.clearPlace()

          return
        }

        if (this.current_fulfillment_type == `pickup` && this.useDefaultPickupPlace()) {
          return
        }

        if (!this.getIsBevmoLocationValidForTab()) {
          this.clearAutocompleteFromBevmoLocation()

          return
        }

        this.placeChanged()
      }

      setDefaultPickupPlace() {
        if (!this.place || !this.getIsPlaceDefaultStore()) {
          return
        }

        const parsedAddress = parseAddressComponents(this.place)

        this.default_pickup_autocomplete = `${parsedAddress.city}, ${parsedAddress.province}`
        this.default_pickup_place = this.place
        this.checkLocation()
      }

      useDefaultPickupPlace() {
        if (!this.default_pickup_place) {
          if (this.getIsBevmoLocationDefaultStore()) {
            if (bevmoLocation?.place?.formatted_address) {
              this.autocompleteInput.value = bevmoLocation?.place?.formatted_address
            } else {
              this.autocompleteInput.value = bevmoLocation.address.autocomplete
            }
            this.placeChanged()

            return true
          }

          return false
        }

        if (bevmoLocation?.place?.formatted_address) {
          this.autocompleteInput.value = bevmoLocation?.place?.formatted_address
        } else {
          this.autocompleteInput.value = this.default_pickup_autocomplete
        }
        this.placeChanged(this.default_pickup_place)

        return true
      }

      onPickupLocationChange(evt) {
        if (!evt.target || !evt.target.matches('input[type="radio"][name="selected_nearest_store"]')) {
          return
        }
        evt.stopPropagation()

        const location_id = parseInt(evt.target.value, 10)
        this.selectedPickupLocationId = location_id

        this.updateConfirmButton()
      }

      onSubmitHandler(evt) {
        evt.preventDefault()
        evt.stopPropagation()

        if (this.updateConfirmButton()) {
          return
        }

        let location_id = null
        let fulfillment_display_name = ""
        let submitAddress = this.address
        let submitPlace = this.place
        
        switch (this.current_fulfillment_type) {
          case "pickup":
            location_id = parseInt(
              this.form.querySelector(`input[type="radio"][name="selected_nearest_store"]:checked`).value,
              10
            )
            const selectedPickupLocation = this.delivery_zone_response.pickup_locations.find(
              (location) => location.id == location_id
            )
            fulfillment_display_name = selectedPickupLocation.friendlyName
            
            // Build address and place from selected pickup location
            const storeAddress = selectedPickupLocation.address || {}
            // Build formatted address avoiding double commas
            const addressParts = []
            if (storeAddress.address) addressParts.push(storeAddress.address)
            if (storeAddress.apt && storeAddress.apt.trim()) addressParts.push(storeAddress.apt)
            if (storeAddress.city) addressParts.push(storeAddress.city)
            const stateZip = storeAddress.state ? 
              `${storeAddress.state} ${storeAddress.zip || ''}`.trim() : 
              (storeAddress.zip || '')
            if (stateZip) addressParts.push(stateZip)
            const addressStr = addressParts.filter(part => part && part.trim()).join(', ')
            
            submitAddress = {
              autocomplete: addressStr,
              place_id: storeAddress.google_place_id,
              city: storeAddress.city,
              province: storeAddress.state,
              address1: storeAddress.address,
              addressStr: addressStr,
              country: selectedPickupLocation.country_code || 'US',
              postalCode: storeAddress.zip,
              latitude: String(storeAddress.latitude),
              longitude: String(storeAddress.longitude),
              unit: storeAddress.apt || '',
            }
            
            // Build place object for pickup location
            submitPlace = {
              place_id: storeAddress.google_place_id,
              formatted_address: addressStr,
              geometry: {
                location: {
                  lat: parseFloat(storeAddress.latitude),
                  lng: parseFloat(storeAddress.longitude)
                }
              },
              address_components: [
                {
                  long_name: storeAddress.address,
                  short_name: storeAddress.address,
                  types: ["street_number", "route"]
                },
                {
                  long_name: storeAddress.city,
                  short_name: storeAddress.city,
                  types: ["locality"]
                },
                {
                  long_name: storeAddress.state,
                  short_name: storeAddress.state,
                  types: ["administrative_area_level_1"]
                },
                {
                  long_name: storeAddress.zip,
                  short_name: storeAddress.zip,
                  types: ["postal_code"]
                }
              ]
            }
            break
          case "delivery":
            location_id = this.delivery_zone_response.delivery_location.id
            fulfillment_display_name = this.address.address1
            submitAddress.unit = this.form.querySelector("[name=unit]").value
            submitAddress.autocomplete = this.place.formatted_address
            break
          default:
            location_id = this.delivery_zone_response.shipping_location.id
            fulfillment_display_name = this.address.address1
            submitAddress.unit = this.form.querySelector("[name=unit]").value
            submitAddress.autocomplete = this.place.formatted_address
        }

        const submitLocation = {
          address: submitAddress,
          fulfillment_type: this.current_fulfillment_type,
          fulfillment_display_name,
          location_id,
          place: submitPlace,
          availabilities: this.availabilities,
        }

        window.bevmoLocation.setLocation(submitLocation)
        this.autocompleteInput.value = submitLocation.place.formatted_address
        this.hide()

        gopuffCustomAnalytics.publishEvent(`gopuff_fulfillment_type_changed`, {
          fulfillment_type: this.current_fulfillment_type,
          location_id: location_id,
        })
      }
    }
  )
}

document.querySelectorAll("[data-show-location-modal]").forEach((trigger) => {
  trigger.addEventListener("click", () => {
    document.querySelector("location-modal").showModal(trigger)
  })

  trigger.addEventListener("keydown", (e) => {
    if (e.key !== `Enter` && e.key !== ` `) {
      return
    }

    e.preventDefault()
    document.querySelector("location-modal").showModal(trigger)
  })
})
